'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndPolicyGroup } from '../../Entities/Ind/IndPolicyGroup';
import { IndPolicyGroupCollection } from '../../Collections/Ind/IndPolicyGroupCollection';

export class IndPolicyGroupRepository extends CoreRepository {
  public createIndPolicyGroup(policyId: number, payload: object = {}) {
    return this.webAPI.createIndPolicyGroup(policyId, payload).then((response) => {
      const individualPolicyGroup = new IndPolicyGroup();
      individualPolicyGroup.hydrate(response);

      return individualPolicyGroup;
    });
  }

  public removeIndPolicyGroup(groupId) {
    return this.webAPI.removeIndPolicyGroup(groupId).then((response) => {
      return response;
    });
  }
  /*
    public getIndPolicyGroups(options: object = {}, criteria: object = null){
        if( !options )
        {
        options = {};
        }

        if( criteria )
        {
        options['criteria'] = criteria;
        }

        return this.webAPI.get(options)
        .then( response => {
            let collection = new IndPolicyGroupCollection();

            response.data.forEach(collectionItemData => {
            let collectionItem = new IndPolicyGroup();
                collectionItem.hydrate(collectionItemData);

            collection.addItem(collectionItem);
            });

            collection.setOffset(response.offset);
            collection.setLimit(response.limit);
            collection.setTotal(response.total);

            return collection;
        });

    }
    */

  /*
    public getIndPolicyGroup(options: object = null){
        if( !options )
        {
        options = {};
        }

        return this.webAPI.getIndPolicyGroup(options)
        .then( response => {
            if( !response )
            {
            return false;
            }

            let IndPolicyGroup = new IndPolicyGroup();
            IndPolicyGroup.hydrate(response);

            return IndPolicyGroup;
        });
    }

   

    public updateIndPolicyGroup(payload: object = {}){  
        return this.webAPI.updateIndPolicyGroup(payload)
        .then( response => {
            let IndPolicyGroup = new IndPolicyGroup();
            IndPolicyGroup.hydrate(response);

            return IndPolicyGroup;
        });
    }

    public removeIndPolicyGroup( ){
        return this.webAPI.removeIndPolicyGroup()
        .then( response => {
            return response;
        });
    }
    */
}
